import cx from 'classnames';
import { capfirst } from 'journalize';
import { Component, h } from 'preact';

import TinyMap from './TinyMap';
import tooltipHTML from '../utils/tooltip-html';

import text from 'Data/text.json';
import MiniBarChart from './MiniBarChart';

interface Props {
  category: string;
  maxNum: number;
  categoryNumbers: { [key: string]: any };
  contest: { [key: string]: any };
  candidates: { [key: string]: any };
  candidatesRender: any;
  linkBase?: string;
}

class AnalysisTableRow extends Component {
  constructor() {
    super();
  }

  render() {
    const {
      category,
      categoryNumbers,
      candidatesRender,
      contest,
      maxNum,
      candidates,
      linkBase,
    } = this.props;

    let categoryClass = cx(
      'category-bar-chart-' + category + '-' + contest.office_slug
    );

    // Labels come from the text doc; fall back to the sheet's category name so
    // a category missing from the doc doesn't break the whole graphic
    const categoryLabel = (text.geocategories || []).find(
      (a) => a.type == category
    );
    const category_text = categoryLabel
      ? categoryLabel['value']
      : capfirst(category);

    const categoryExplain = (text.geocategories_explain || []).find(
      (a) => a.type == category
    );
    const category_explain = categoryExplain ? categoryExplain['value'] : '';

    const categoryTooltip = (text.geocategories_tooltip || []).find(
      (a) => a.type == category
    );
    const category_tooltip = categoryTooltip ? categoryTooltip['value'] : '';
    const tooltipId = `category-info-tooltip-${category}-${contest.office_slug}`;

    return (
      <div class='category-grid t-sans'>
        <h4 class='map__title'>
          {category_text}
          {category_tooltip && (
            <span class='category__info'>
              <button
                type='button'
                class='category__info-pill'
                aria-label={`About ${category_text.toLowerCase()}`}
                aria-describedby={tooltipId}
              >
                <svg class='icon icon-info' aria-hidden='true'>
                  <use xlinkHref='#icon-info'></use>
                </svg>
              </button>
              <span
                id={tooltipId}
                role='tooltip'
                class='category__info-tooltip'
                dangerouslySetInnerHTML={{
                  __html: tooltipHTML(category_tooltip, linkBase),
                }}
              />
            </span>
          )}
        </h4>
        {category_explain && (
          <p
            class='map__explain'
            dangerouslySetInnerHTML={{ __html: category_explain }}
          />
        )}
        <div class='category-inline-grid'>
          <TinyMap
            contest={contest}
            category={category}
            candidatesRender={candidatesRender}
          />
          <div class={categoryClass}>
            <MiniBarChart
              className={category}
              maxNum={maxNum}
              officeSlug={contest.office_slug}
              categoryNumbers={categoryNumbers}
              candidatesRender={candidatesRender}
              candidates={candidates}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default AnalysisTableRow;